var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{key:_vm.lang,attrs:{"app":""}},[_c('HeaderComponent'),_c('v-main',[_c('router-view'),_c('div',{attrs:{"id":"fb-root"}})],1),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }